import {
  BodySection,
  ButtonSection,
  Caption,
  CaptionIcon,
  Content,
  Header,
  Heading,
  Icons,
  IconsSection,
  Title
} from './styles';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import ButtonV2 from '../button/buttonV2';
import LayoutWithoutNavbar from '../layoutWithoutNavbar';
import { BUTTON_TYPE } from '../../global/constants';

export default function NotionAuth() {
  return (
    <>
      <LayoutWithoutNavbar>
        <Header>
          <SVGIcon name='black-teamcamp-logo' width='18' height='18' viewBox='0 0 18 18' />
          <p>Teamcamp</p>
        </Header>
        <Content>
          <IconsSection>
            <Icons>
              <SVGIcon name='modal-notion-icon' width='40' height='40' viewBox='0 0 20 20' />
            </Icons>
            <SVGIcon name='transfer-icon' width='36' height='36' viewBox='0 0 36 36' />
            <Icons>
              <SVGIcon name='black-teamcamp-logo' width='40' height='40' viewBox='0 0 18 18' />
            </Icons>
          </IconsSection>
          <Heading>Notion Platform is requesting permission to access the Teamcamp workspace</Heading>
          <BodySection>
            <Title>What will Notion Platform be able to view?</Title>
            <Caption>
              <CaptionIcon>
                <SVGIcon
                  name='navbar-MyTask-icon'
                  width='18'
                  height='18'
                  viewBox='0 0 18 18'
                  stroke='var(--text-secondary)'
                />
              </CaptionIcon>
              <p>Content and info about your task title, description and assignee.</p>
            </Caption>
            <Caption>
              <CaptionIcon>
                <SVGIcon name='navbar-project-icon' width='18' height='18' viewBox='0 0 18 18' />
              </CaptionIcon>
              <p>Content and info about your project title and members.</p>
            </Caption>
          </BodySection>
          <ButtonSection>
            <ButtonV2 title='Cancel' variant={BUTTON_TYPE.SECONDARY} />
            <ButtonV2 title='Allow' variant={BUTTON_TYPE.PRIMARY} />
          </ButtonSection>
        </Content>
      </LayoutWithoutNavbar>
    </>
  );
}
